// Module
var code = "<ng-include ng-if=\"AuthService.isUser() || AuthService.isBikeOrganisationOwner() || AuthService.isBikeBusinessSupervisor()\"\n            src=\"'template/settings/tabs/payment/payment.html'\"></ng-include>\n";
// Exports
var _module_exports = code;;
var path = 'template/settings/tabs/profile-payment.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;